module.exports = __webpack_public_path__ + "img/bz.801ec1f3.svg";